import {FC, useState, useEffect} from 'react'
import {IDatePickerMode, ILanguage} from '../../types/common'
import {registerLocale} from 'react-datepicker'
import {pl, enUS} from 'date-fns/locale'
import YearMonthPicker from '../../common/YearMonthPicker'
import {useTranslation} from 'react-i18next'
import InfoBox from '../../common/InfoBox'

registerLocale('pl', pl)
registerLocale('en', enUS)

const FilterCompared: FC<{
    language: ILanguage
    excluded: Array<string>
    ctx: any
}> = ({language, ctx, excluded}) => {
    const {t} = useTranslation()
    const [excludedDays, setExcludedDays] = useState<Array<Date>>()
    const [selectedDate, setSelectedDate] = useState<Date | undefined>()
    const [datePickerMinDate, setDatePickerMinDate] = useState<Date | undefined>()
    const [datePickerMaxDate, setDatePickerMaxDate] = useState<Date | undefined>()

    useEffect(() => {
        setDatePickerMaxDate(ctx.maxDate)
        setDatePickerMinDate(ctx.minDate)
    }, [ctx.minDate, ctx.maxDate])

    useEffect(() => {
        setSelectedDate(ctx.date)
    }, [ctx.date])

    useEffect(() => {
        setExcludedDays(ctx.holiday)
    }, [ctx.holiday])

    return (
        <>
            <section id="compare-container-toolbar" className="flex">
                {excluded.length > 0 && ctx.getItem('excluded:' + excluded.join(':')) !== 'hidden' && (
                    <InfoBox
                        title={t('label.infobox.unit.unreachable')}
                        onCloseCallback={() => {
                            ctx.setItem('excluded:' + excluded.join(':'), 'hidden')
                        }}
                    />
                )}

                <div className="filter-bar flex">
                    <div className="up-filter-bar">
                        <div className="grid-column flex">
                            <div className="datepickers-item flex">
                                <label className="datepickers-item-label">{t('label.datepicker.title2')}</label>
                                <YearMonthPicker
                                    language={language}
                                    selectedDate={selectedDate}
                                    setSelectedDate={setSelectedDate}
                                    datePickerMinDate={datePickerMinDate}
                                    datePickerMaxDate={datePickerMaxDate}
                                    excludeDates={excludedDays}
                                    withCurrentDate={true}
                                    filterDate={(date) => {
                                        return date.getDay() !== 0 && date.getDay() !== 6
                                    }}
                                    onDateChangeCallback={(date) => {
                                        ctx.setDate(date)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {/*<div className="filters-delete flex">*/}
                    {/*    <div className="delete-all flex">*/}
                    {/*        <div className="link-delete">Wyczyść filtry</div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </section>
        </>
    )
}

export default FilterCompared
